var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9321 -8200)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-9321 8200)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12243.783 5854.877)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2949.4,2357.852a2.914,2.914,0,0,0-.888-2.092q-1.6-1.592-3.188-3.187a3.033,3.033,0,0,0-2.22-.938q-3.159,0-6.317,0a17.579,17.579,0,0,0-2.054.038,2.849,2.849,0,0,0-2.558,2.885c-.014.665,0,1.332,0,2q0,3.341,0,6.682h-.007q0,.948,0,1.9,0,3.246.009,6.492a3.593,3.593,0,0,0,.038.582,2.777,2.777,0,0,0,1.09,1.846,3.085,3.085,0,0,0,1.921.566q5.376-.005,10.752,0c.243,0,.487.005.729-.009a2.729,2.729,0,0,0,2.142-1.157,3.252,3.252,0,0,0,.55-1.975q0-5.288,0-10.577C2949.4,2359.884,2949.409,2358.868,2949.4,2357.852Zm-5.186-3.784c0-.013,0-.027.011-.072l2.92,2.835c-.033.053-.076.031-.11.031l-2.681,0c-.083,0-.144.006-.143-.115C2944.212,2355.855,2944.21,2354.961,2944.21,2354.067Zm3.038,17.477a2.863,2.863,0,0,1-.026.494.473.473,0,0,1-.5.467c-.164.016-.329.026-.495.027H2935.36a2.494,2.494,0,0,1-.565-.051.587.587,0,0,1-.508-.557,3.316,3.316,0,0,1-.028-.494q0-4.15,0-8.3,0-4.208,0-8.417c0-.053,0-.107,0-.161a.717.717,0,0,1,.763-.777c.082-.007.165-.007.248-.007l6.243-.006a3.708,3.708,0,0,1,.466.008.287.287,0,0,1,.294.284,1.712,1.712,0,0,1,.007.218c0,1.07,0,2.139,0,3.209a1.293,1.293,0,0,0,.231.755,1.192,1.192,0,0,0,1.006.527c1.06.015,2.119.037,3.179.005.475-.014.568.076.565.551C2947.237,2363.4,2947.254,2367.47,2947.248,2371.545Z",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3004.615,2531.99q1.56,0,3.12,0a1.123,1.123,0,0,1,.827.3,1.026,1.026,0,0,1,.282,1.1.968.968,0,0,1-.84.672,4.954,4.954,0,0,1-.811.062q-2.6,0-5.191,0a3.771,3.771,0,0,1-.881-.09.906.906,0,0,1-.759-1.069.951.951,0,0,1,.844-.944,1.726,1.726,0,0,1,.3-.026Z",
    transform: "translate(-63.83 -168.82)",
    fill: "#71aff8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3004.527,2600.335c1.1,0,2.207,0,3.311,0a.933.933,0,0,1,.952.764,1.011,1.011,0,0,1-.523,1.141,1.478,1.478,0,0,1-.7.159q-3,.005-6.009,0a1.47,1.47,0,0,1-.879-.211.852.852,0,0,1-.312-.375,1.114,1.114,0,0,1,.266-1.29,1.006,1.006,0,0,1,.6-.187h3.3Z",
    transform: "translate(-63.747 -232.789)",
    fill: "#71aff8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWon);
export default __webpack_public_path__ + "static/media/icon-won.6a4e0ad7.svg";
export { ForwardRef as ReactComponent };